import Axios from "axios";
import {
  getLcImportDocumentList,
  getLcImportDocumentById,
  saveLcImportDocument,
  updateLcImportDocument,
} from "@/store/api";
import {
  SET_LC_IMPORT_DOCUMENT_LIST,
  UNSET_LC_IMPORT_DOCUMENT_LIST,
} from "@/store/mutation-types";

const state = {
  lcImportDocumentList: [],
};

const getters = {
  getLcImportDocumentList(state) {
    return state.lcImportDocumentList;
  },
};

const mutations = {
  [SET_LC_IMPORT_DOCUMENT_LIST](state, data) {
    state.lcImportDocumentList = data;
  },
  [UNSET_LC_IMPORT_DOCUMENT_LIST](state) {
    state.lcImportDocumentList = [];
  },
};

const actions = {
  // List
  getLcImportDocumentList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcImportDocumentList)
        .then((response) => {
          if (response.data?.success) {
            commit(SET_LC_IMPORT_DOCUMENT_LIST, response.data.data || []);
          } else {
            commit(UNSET_LC_IMPORT_DOCUMENT_LIST);
          }
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_LC_IMPORT_DOCUMENT_LIST);
          reject(error);
        });
    });
  },

  // Create / Update (with file upload)
  saveUpdateLcImportDocument({ commit }, data) {
    commit("SET_LOADING", { color: "primary" }, { root: true });

    return new Promise((resolve, reject) => {
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // Use Laravel form-method override for PUT
      const isUpdate = !!data.id;
      let url = saveLcImportDocument;
      let method = "post";

      if (isUpdate) {
        url = `${updateLcImportDocument}${data.id}`;
        formData.append("_method", "PUT");
      }

      Axios[method](url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .then(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  // Optional: fetch single document (for edit)
  getLcImportDocumentById(_, id) {
    return Axios.get(`${getLcImportDocumentById}${id}`);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

